import { IJsonQueryRailway } from '../../../../api-models/common/json_query';
import { createGeoTagsManager } from '../../utils/createGeoTagsManager';

export const geoRailwayTagsManager = createGeoTagsManager<IJsonQueryRailway>({
  jsonQueryKey: 'railway',
  labelGetter: ({ geoTags, geoValue }) => geoTags.railways[geoValue.id] || 'Неизвестная Ж/Д станция',
  id: 'geoRailway',
});
